import {
  gold,
  green,
  blue,
  purple,
  lime,
  orange,
  geekblue,
} from "@ant-design/colors";

export const colors = {
  aragroColor: "#02c9ab",
  brandColor: "#007bff",
  successColor: "#52c41a",
  dangerColor: "#ff4d4f",
  warningColor: "#faad14",
  disabledColor: "#bfbfbf",
  completedColor: "#1a173b",
  alternateColor: "#f3f3f3",
};

export const statusColors = {
  new: "#9ecef5",
  open: "cyan",
  completed: "green",
  canceled: "red",
  closed: "#111111",
  submitted: "#13c2c2",
  inProgress: "blue",
  overdue: "volcano",
  due: "cyan",
  due_soon: "orange",
  awaitingInventory: "gold",
  reverted: "magenta",
  awaitingApproval: "blue",
  rejected: "red",
  approved: "geekblue",
};

export const fixedColors = [
  gold[0],
  green[0],
  blue[0],
  lime[0],
  geekblue[0],
  orange[0],
  purple[0],
];
